<template>
  <div class="realEstate">

    <div class="edit-area">

      <h2 class="normal">绘制板块</h2>

      <div class="edit-area-content">

        <div class="normal">板块名：{{area_name}}</div>

        <el-button @click="lnglatToDots" type="primary">一键恢复</el-button>
        <el-button @click="reverseLine" type="primary">反转</el-button>

        <div class="normal">行政区:<input type="text" @keydown.enter="districtSearch" v-model="district"></div>

        <div class="normal">周边板块:<input type="text" @keydown.enter="addNearArea" v-model="nearArea"></div>

        <button @click="upToDb" class="up">上传数据库</button>

        <div class="normal">
          <p>在画的点:{{drawDotNum}}</p>
          数量：<input type="number" @keydown.enter="changeDrawNum">
          间隔：<input type="number" v-model="drawDotStep">
          <div>
            <el-button type="primary" @click="drawBack">后</el-button>
            <el-button type="primary" @click="drawForward">前</el-button>
          </div>
        </div>
        <div class="normal">
          <p>起始点移动</p>
          <div>
            <el-button type="primary" @click="startBack">后</el-button>
            <el-button type="primary" @click="startForward">前</el-button>
          </div>
        </div>
        <div class="normal">
          <p>辅助的点:{{showDotNum}}</p>
          数量：<input type="number" @keydown.enter="changeShowNum">
          间隔：<input type="number" v-model="showDotStep">
          <div>
            <el-button type="primary" @click="showBack">后</el-button>
            <el-button type="primary" @click="showForward">前</el-button>
          </div>
        </div>
 
      </div>

    </div>

    <div id="area_container" :style="mapHeight">
      <el-amap class="amap-box" vid="real_map" ref="real_map" :zoom="zoom" :center="center" :amap-manager="amapManager"
        :plugin="plugin" :events="events">
        <el-amap-polyline v-for="(dots,index) in dotsList" :key="'polyline' + index" editable=false :path="dots"
          strokeColor="#97E81D" strokeWeight=2></el-amap-polyline>
        <el-amap-polyline editable=false :path="dots" strokeColor="red" strokeWeight=2></el-amap-polyline>
        <span v-for="(pos,index) in lnglatList" :key="'history' + index">
          <el-amap-marker :vid="'all_marker' + index"  :zIndex="101"
           v-if="index < showDotIndex + showDotNum && index >= showDotIndex"
          :position="pos.split('|')" :events="allMarkerEvents" :offset="[-10,-30]"></el-amap-marker>
        </span>
        <span v-for="(pos,index) in lnglat" :key="'current' + index">
          <el-amap-marker :vid="'lnglat_marker' + index" v-if="index < drawDotIndex + drawDotNum && index >= drawDotIndex || index > lnglat.length - 5"
          :position="pos.split('|')" :events="lnglatMarkerEvents" icon="./../../static/images/marker.png" :zIndex="101"
          :offset="[-16,-27]" :draggable="true"></el-amap-marker>
        </span>
        <el-amap-marker vid="area_center" :position="area_center.split('|')" icon="./../../static/images/marker1.png" v-if="area_center"></el-amap-marker>
      </el-amap>
    </div>

  </div>
</template>

<script>
  import {
    AMapManager
  } from "vue-amap"
  let amapManager = new AMapManager();
  export default {
    data() {
      return {
        area_name: '',
        location_id: '',
        area_id: '',
        dots: [],
        lnglat: [],
        dotsList: [],
        lnglatList: [],
        district: '',
        nearArea: '',

        location_size: '',
        location_type: '商场',
        school_type: '小学',
        private_public: '公办',

        mapHeight: {},

        searchOption: {
          city: '杭州',
          citylimit: true
        },
        zoom: 15,
        center: [120.051238, 30.228232],
        amapManager,
        events: {
          'rightclick': (e) => {
            console.log('右点击地图')
            let that = this
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.dots.push(dot)
            that.lnglat.push(dot.join('|'))
          },
          'click': (e) => {
            let that = this
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.area_center = dot.join('|')
          }
        },
        plugin: [{
          //地图类型，卫星地图和普通地图
          pName: 'MapType',
          defaultType: 0,
        }],
        markers: [],

        lnglatMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            that.dots.splice(index, 1)
            that.lnglat.splice(index, 1)
          },
          'click': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            that.dots.push(that.lnglat[index].split('|'))
            // let lnglat1 = that.lnglat.slice(0,index);
            // let lnglat2 = that.lnglat.slice(index);
            // that.lnglat = lnglat2.concat(lnglat1);
            // let dots1 = that.dots.slice(0,index);
            // let dots2 = that.dots.slice(index);
            // that.dots = dots2.concat(dots1);
            // console.log('index', index);
          },
          'dragging': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.dots.splice(index, 1, dot)
            that.lnglat.splice(index, 1, dot.join('|'))
          }
        },
        allMarkerEvents: {
          'click': (e) => {
            let that = this
            let index = e.target.w.vid.replace('all_marker', '')
            that.dots.push(that.lnglatList[index].split('|'))
            that.lnglat.push(that.lnglatList[index])
          }
        },

        area_center: '',

        drawDotNum: 10,
        showDotNum: 10,
        drawDotStep: 10,
        showDotStep: 10,
        drawDotIndex: 0,
        showDotIndex: 0,
        startDotStep: 10,
        modelMap: {
          '杭州': 'WpAreaModel',
          '苏州': 'SzAreaModel',
          '天津': 'TjAreaModel',
          '绍兴': 'SxAreaModel',
          '宁波': 'NbAreaModel',
        },

        hasImageLayer: false
      }
    },
    created() {
      let height = window.innerHeight + 'px';
      console.log(height)
      this.mapHeight.height = height
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        delete origin.mapHeight;
        delete origin.events;
        delete origin.lnglatMarkerEvents;
        delete origin.allMarkerEvents;
        delete origin.hasImageLayer;
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      init() {
        let that = this;
        let obj = that.$route.params
        let city = that.$store.state.Counter.city;
        that.searchOption.city = city;
        that.center = that.$getMapCenter();
        that.$axios.get(that.$url_prefix + 'queryAreaDetail', {
          params: {
            area_id: obj.id
          }
        }).then(function (res) {
          console.log('查询板块返回', res)
          let area = res.data.data
          that.area_name = area.area_name
          that.area_id = area.id
          if (area.dots) {
            that.lnglat = area.dots.split('-')
            let temp = area.dots.split('-')
            for (let i = 0; i < temp.length; i++) {
              temp[i] = temp[i].split('|')
            }
            temp.push(temp[0])
            that.dots = temp
            if(area.center){
              that.center = area.center.split('|')
              that.area_center = area.center
            }
          } else {
            that.lnglat = []
            that.dots = []
          }

          if (!that.hasImageLayer) {
            if (city === '苏州') {
              // let currentMap = that.amapManager.getMap()
              // let imageLayer = new AMap.ImageLayer({
              //   url: 'https://www.xaoji.com:3001/upload/image/suzhou_kunshan_map.png',
              //   bounds: new AMap.Bounds([120.491767,31.016259], [121.006751,31.632142]),
              //   zooms: [2, 25],
              //   opacity: 0.7,
              //   map: currentMap,
              //   zIndex: 100
              // });
              // that.hasImageLayer = true;
            } else if (city === '天津') {
              let currentMap = that.amapManager.getMap()
              let imageLayer = new AMap.ImageLayer({
                url: 'https://www.xaoji.com:3001/upload/image/tianjinbankuai.png',
                bounds: new AMap.Bounds([116.611215, 38.530935],[118.121835,40.255382]),
                zooms: [5, 25],
                opacity: 0.5,
                map: currentMap,
                zIndex: 100
              });
              that.hasImageLayer = true;
            } else if (city === '宁波') {
              let currentMap = that.amapManager.getMap()
              let imageLayer = new AMap.ImageLayer({
                url: 'https://www.xaoji.com:3001/upload/image/ningbobankuai.png',
                bounds: new AMap.Bounds([120.934954,29.262253],[122.308246,30.453224]),
                zooms: [5, 25],
                opacity: 0.5,
                map: currentMap,
                zIndex: 100
              });
              that.hasImageLayer = true;
            }
          }

          // that.drawLimitArea("xlc3413tjd");

        }).catch(function (res) {
          console.log('查询板块失败', res)
        })

      },

      drawLimitArea(id) {
        let that = this;
        that.$axios.get(that.$url_prefix + 'queryOneById', {
          params: {
            id: id,
            db: 'AreaPlanModel'
          }
        }).then(function (res) {
          let plan = res.data.data;
          let currentMap = amapManager.getMap();

          that.imageLayer = new AMap.ImageLayer({
            url: plan.image,
            bounds: new AMap.Bounds(plan.southwest.split('|'), plan.northeast.split('|')),
            zooms: [12, 18],
            opacity: 0.5,
            map: currentMap
          });
        }).catch(function (res) {
          console.log('query fail', res);
          that.$message.error('查询失败, 请检查网络');
        })
      },


      //上传数据库
      upToDb() {
        let that = this

        let obj = {}

        if (that.area_id.length === 0) {
          return;
        }

        obj.dots = that.lnglat.join('-')
        obj.id = that.area_id

        
        obj.center = that.area_center

        let param = {
          'db': that.modelMap[that.$store.state.Counter.city],
          'model': 'edit',
          'item': JSON.stringify(obj)
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (want) {
          console.log('上传板块返回', want)
          // that.area_name = ''
          // that.dots = []
          // that.lnglat = []
          // that.area_id = ''
          // that.area_center = ''
          // alert('上传成功')
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('上传地段失败', res)
        })


      },

      districtSearch() {
        let that = this
        if (that.district.length === 0) {
          return
        }
        let currentMap = that.amapManager.getMap()
        let district = new AMap.DistrictSearch({
          // 返回行政区边界坐标等具体信息
          extensions: 'all',
          // 设置查询行政区级别为 区 
          level: 'district'
        })
        district.search(that.district, function (status, result) {
          console.log('result', result)
          let bounds = result.districtList[0].boundaries
          let polygons = []
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              //生成行政区划polygon
              let polygon = new AMap.Polygon({
                map: currentMap,
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0,
                bubble: true,
                // fillColor: '#CCF3FF',
                strokeColor: '#CC66CC'
              })
              polygons.push(polygon)
            }
          }
        })
      },
      lnglatToDots() {
        let that = this
        let temp = JSON.parse(JSON.stringify(that.lnglat))
        for (let i = 0; i < temp.length; i++) {
          temp[i] = temp[i].split('|')
        }
        that.dots = temp
      },
      
      addNearArea() {
        let that = this
        if (that.nearArea.length === 0) {
          return
        }
        that.$axios.get(that.$url_prefix + 'queryAreaDetail', {
          params: {
            area_name: that.nearArea
          }
        }).then(function (res) {
          console.log('查询板块返回', res)
          if (res.data.data.dots && res.data.data.dots.length > 0) {
            let list1 = res.data.data.dots.split('-')
            let list2 = res.data.data.dots.split('-')
            that.lnglatList = that.lnglatList.concat(list1)
            for (let k = 0; k < list2.length; k++) {
              list2[k] = list2[k].split('|')
            }
            list2.push(list2[0])
            that.dotsList.push(list2)
          }
        }).catch(function (res) {
          console.log('查询板块失败', res)
        })
      },

      drawBack() {
        let step = parseInt(this.drawDotStep);
        let result = this.drawDotIndex - step;
        if (result < 0) {
          result = 0;
        }
        this.drawDotIndex = result
      },
      drawForward() {
        let step = parseInt(this.drawDotStep);
        let result = this.drawDotIndex + step;
        let num = parseInt(this.drawDotNum) || 0;
        let limit = this.lnglat.length - num;
        if (result > limit) {
          result = limit;
        }
        if (result < 0) {
          result = 0;
        }
        this.drawDotIndex = result
      },
      showBack() {
        let step = parseInt(this.showDotStep);
        let result = this.showDotIndex - step;
        if (result < 0) {
          result = 0;
        }
        this.showDotIndex = result
      },
      showForward() {
        let step = parseInt(this.showDotStep);
        let result = this.showDotIndex + step;
        let num = parseInt(this.showDotNum) || 0;
        let limit = this.lnglatList.length - num;
        if (result > limit) {
          result = limit;
        }
        if (result < 0) {
          result = 0;
        }
        this.showDotIndex = result
      },
      changeDrawNum(e) {
        let value = parseInt(e.target.value);
        if (value) {
          this.drawDotNum = value;
        }
      },
      changeShowNum(e) {
        let value = parseInt(e.target.value);
        if (value) {
          this.showDotNum = value;
        }
      },

      sortDots() {
        this.lnglat.reverse();
        this.dots.reverse();
      },

      startBack() {
        let step = parseInt(this.startDotStep);
        if (this.lnglat.length > step) {
          let list = this.lnglat.slice(step);
          for (let i=0; i<step; i++) {
            list.push(this.lnglat[i]);
          }
          this.lnglat = list;
          this.dots = list.map(x => {
            return x.split('|');
          })
        }
      },
      startForward() {
        let step = parseInt(this.startDotStep);
        if (this.lnglat.length > step) {
          let list = this.lnglat.slice(0, this.lnglat.length - step);
          for (let i=this.lnglat.length - 1; i>this.lnglat.length - 1 - step; i--) {
            list.unshift(this.lnglat[i]);
          }
          this.lnglat = list;
          this.dots = list.map(x => {
            return x.split('|');
          })
        }
      },

      reverseLine() {
        this.lnglat.reverse();
        this.dots.reverse();
        this.$message({
          message: '反转成功',
          type: 'success'
        })
      },

    }
  }

</script>

<style scoped>

  button {
    outline: none;
  }

  .realEstate {
    display: flex;
    width: 100%;
  }

  .realEstate .edit-area {
    text-align: center;
    width: 30%;
  }

  .realEstate #area_container {
    width: 70%;
    position: fixed;
    top: 0;
    left: 30%;
  }

  #area_container .search-box {
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid black;
  }

  .imageBox {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
  }

  .imageBox .imageItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

  .up {
    margin-top: 20px;
    width: 150px;
    height: 50px;
    border-radius: 10px
  }

  .adImg {
    height: 100px;
  }

  .line {
    margin-top: 20px;
    color: #ccc;
  }

  .normal {
    margin: 10px 0;
  }

  .white {
    height: 50px;
  }

  .salesmanList {
    display: flex;
    flex-wrap: wrap;
  }

  .salesman {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 20px;
  }

  .salesman img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  input {
    width: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/page/drawArea.vue